<template>
  <PagesExhibitionsComponent
    :pageData="data"
    :childData="childData"
    :paginateChildData="paginateChildData"
  />
</template>

<script setup>
useHead(({
  htmlAttrs: { 'data-page': 'exhibitions' },
}))

// 1
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryExhibitionsPage() } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)

// 2
const { data: childData, error: childError } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryExhibitionEntryThumbnails(baseRouteGetPublicationStateQuery()) } }
  )
})

const paginateChildData = async () => {
  const { data: nextData, error: nextError } = await useAsyncData(() => {
    return $fetch('/api/strapi-rest',
      { query: { path: queryExhibitionEntryThumbnails({ ...baseRouteGetPublicationStateQuery(), page: childData?.value?.meta?.pagination?.page + 1 }) } }
    )
  })

  if (nextData?.value) {
    childData.value.data = childData.value.data.concat(nextData.value.data)
    childData.value.meta = nextData.value.meta
  }
}
</script>
